class InstitutionsSelect {
	constructor(config) {
		this.config = config;
	}

	get institutionLinkElement() {
		return Array.from(document.querySelectorAll(this.config.institutionLinkElement));
	}

	get institutionsSelectElement() {
		return Array.from(document.querySelectorAll(this.config.institutionsSelectElement));
	}

	hideInstitutionLinkElement() {
		for (const item of this.institutionLinkElement) {
			item.classList.add('u-display-none');
		}
	}

	showInstitutionsSelectElement() {
		for (const item of this.institutionsSelectElement) {
			item.parentElement.classList.remove('u-display-none');
			item.classList.remove('u-display-none');
		}
	}

	// listen to select change
	institutionsSelectElementListener() {
		for (const item of this.institutionsSelectElement) {
			item.addEventListener('change', () => {
				if (item.value !== '' && item.value !== undefined) {
					window.location.href = item.value;
				}
			});
		}
	}

	init() {
		this.hideInstitutionLinkElement();
		this.showInstitutionsSelectElement();
		this.institutionsSelectElementListener();
	}
}

export default InstitutionsSelect;
